var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "clickoutside",
          rawName: "v-clickoutside",
          value: _vm.changeShowProduct,
          expression: "changeShowProduct",
        },
      ],
      staticClass: "change-product",
      class: _vm.show ? "show" : "hide",
    },
    _vm._l(_vm.products, function (item) {
      return _c("div", { key: item.key, staticClass: "product" }, [
        _c(
          "div",
          [
            _c("svg-icon", {
              staticStyle: { "font-size": "28px" },
              attrs: { name: item.key },
            }),
            _c("div", { staticClass: "name" }, [_vm._v(_vm._s(item.name))]),
            _c(
              "el-button",
              {
                class: item.permission ? "confirm-btn-plain" : "disable-btn",
                attrs: { size: "mini" },
                on: {
                  click: function ($event) {
                    return _vm.goProduct(item)
                  },
                },
              },
              [
                !item.permission
                  ? _c("svg-icon", { attrs: { name: "lock" } })
                  : _vm._e(),
                _vm._v("  " + _vm._s(_vm.$t("header.enter")) + " "),
              ],
              1
            ),
          ],
          1
        ),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }